import { z } from "zod";

export const UpdateAbandonedCartConfigRequestSchema = z.object({
  enabled: z.boolean(),
});

export const AbandonedCartConfigResponseSchema = z.object({
  enabled: z.boolean(),
});

export type UpdateAbandonedCartConfigRequest = z.infer<
  typeof UpdateAbandonedCartConfigRequestSchema
>;
export type AbandonedCartConfigResponse = z.infer<
  typeof AbandonedCartConfigResponseSchema
>;
